/** Link validation errors to inputs and focus first error (ADA). */
const errorMsgs = [...document.querySelectorAll('[data-valmsg-for]')];

function findFirstElementWithClass(
  elements: Element[],
  className: string,
): Element | undefined {
  return elements.find((element) => element.classList?.contains(className));
}

if (errorMsgs.length !== 0) {
  errorMsgs.forEach((errorMsg) => {
    const errorMsgId = errorMsg.getAttribute('data-valmsg-for');
    if (!errorMsgId) return;

    errorMsg.setAttribute('id', `${errorMsgId}0`);
    const inputErrorElement = document.getElementById(errorMsgId);
    inputErrorElement?.setAttribute('aria-describedby', `${errorMsgId}0`);
  });

  const firstErrorMsg = findFirstElementWithClass(errorMsgs, 'field-validation-error');
  const errorMsgId = firstErrorMsg?.getAttribute('data-valmsg-for');
  const inputElement = errorMsgId ? document.getElementById(errorMsgId) : null;
  (inputElement as HTMLElement | null)?.focus();
}
